// UI state is local and does not require side effects, so no saga is needed for now.
export default function* uiRootSaga() {
  // No side effects for UI
}
